import { create } from "zustand";

/**
 * Búsqueda global compartida entre el topbar (F1) y la grilla de Venta.
 * El App.tsx escribe `query` desde el input grande; la página Venta lo lee
 * para filtrar productos en vivo.
 */
interface SearchState {
  query: string;
  setQuery: (q: string) => void;
  clear: () => void;
}

export const useSearch = create<SearchState>((set) => ({
  query: "",
  setQuery: (q) => set({ query: q }),
  clear: () => set({ query: "" }),
}));
